import React from 'react';
require('bugsnag-js');

export default class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		Bugsnag.apiKey = "f6dee18b86bce40666683ff4ea2855cc";
		this.state = { hasError: false };
	}

	static getDerivedStateFromError(error) {
		// Update state so the next render will show the fallback UI.
		return { hasError: true, error };
	}

	componentDidCatch(error, errorInfo) {
		// You can also log the error to an error reporting service
		if (window.env != 'local') {
			// if _scripts not loaded yet we have to setup the bugsnag key
			Bugsnag.apiKey = "f6dee18b86bce40666683ff4ea2855cc";
			Bugsnag.notify(
				'JavaScript React error',
				'type: react error',
			);
		}

		/*
		this.setState({
			error,
			errorInfo,
			hasError: true
		})
		*/

		this.setState({
			error,
			errorInfo
		})
	}

	render() {
		if (this.state.hasError) {
			return <div>
				<h2>Something went wrong. Please try again later.</h2>
			</div>;
		}

		return this.props.children;
	}
}



